<template>
  <div class="list-container">
    <!-- 技术概念 -->
    <div class="page1" v-loading="loading" v-if="keywordFlag && conceptList.length > 0">
      <h3>技术概念</h3>
      <div class="page1-main">
        <el-tabs v-model="editableTabsValue" @tab-click="handleClickTab" ref="tabs">
          <el-tab-pane v-for="(item, index) in conceptList" :key="index" :label="item.name" :name="item.name" lazy>
            <p class="page1-load" v-if="descLoading">技术概念解析<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
            <div v-if="conceptVal && !descLoading" class="content">
              <typewriter :text="conceptVal" :speed="15"></typewriter>
            </div>
          </el-tab-pane>
        </el-tabs>
        <p class="tips" v-if="conceptList.length > 0"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
      </div>
    </div>
    <div class="wapper">
      <div class="tab-main">
        <el-tabs v-model="activeName">
          <el-tab-pane label="论文" name="1"></el-tab-pane>
          <el-tab-pane label="作者" name="2"></el-tab-pane>
          <el-tab-pane label="机构" name="3"></el-tab-pane>
          <el-tab-pane label="期刊" name="4"></el-tab-pane>
        </el-tabs>
      </div>
      <template v-if="conceptId">
        <div class="tab-content" v-if="activeName == '1'">
          <article-list :parentData="editableTabsValue" :parentConceptId="conceptId" ref="childRef"></article-list>
        </div>
        <div class="tab-content" v-if="activeName == '2'">
          <author-list :parentData="editableTabsValue" :parentConceptId="conceptId" ref="childRef"></author-list>
        </div>
        <div class="tab-content" v-if="activeName == '3'">
          <institution-list :parentData="editableTabsValue" :parentConceptId="conceptId" ref="childRef"></institution-list>
        </div>
        <div class="tab-content" v-if="activeName == '4'">
          <journal-list :parentData="editableTabsValue" :parentConceptId="conceptId" ref="childRef"></journal-list>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../utils/eventBus";
import typewriter from "@/components/typewriter.vue";
import ArticleList from "../Trend/article";
import AuthorList from "../Trend/author";
import InstitutionList from "../Trend/institution";
import JournalList from "../Trend/journal";
export default {
  data() {
    return {
      loading: false,
      tabIndex: 0,
      keywordFlag: true,
      conceptList: [], //技术概念tab
      editableTabsValue: "", //选中的值
      subjectId: "",
      conceptVal: "",
      activeName: "1",
      conceptId: "",
    };
  },
  components: {
    typewriter,
    ArticleList,
    AuthorList,
    InstitutionList,
    JournalList,
  },

  mounted() {
    EventBus.$on("submitSubject", id => {
      // 使用 Vue Router 移除参数
      this.$router.replace({
        path: this.$route.path, // 保持当前路径
        query: {}, // 清空所有查询参数
      });

      this.getSubjectId(id);
    });
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听，避免重复注册
    EventBus.$off("submitSubject");
  },
  methods: {
    // 从顶部获取到选中的学科
    getSubjectId(id) {
      window.clearInterval(this.timer);
      this.$nextTick(() => {
        if (this.$refs.childRef && typeof this.$refs.childRef.clearSearch === 'function') {
          this.$refs.childRef.clearSearch();
        }
      });
      this.subjectId = id;
      this.getConceptList();
    },
    // tab列表
    getConceptList() {
      this.$http({
        url: `api/v1/subject/gateway/concept/list?subjectId=${this.subjectId}`,
        method: "get",
      }).then(res => {
        this.$nextTick(() => {
          this.loading = false;
          this.conceptList = res.data;
          if (this.conceptList.length > 0) {
            setTimeout(() => {
              this.isRightArrow();
            }, 300);
            if (this.$route.query.value) {
              this.editableTabsValue = this.$route.query.value;
              this.conceptId = this.$route.query.conceptId;
              this.activeName = this.$route.query.type;
            } else {
              this.editableTabsValue = this.conceptList[0].name;
              this.conceptId = this.conceptList[0].conceptId;
            }

            this.descLoading = true;

            setTimeout(() => {
              this.getDescription();
            }, 1200);
          }
        });
      });
    },
    // 动态显示隐藏左右箭头
    isRightArrow() {
      this.$nextTick(() => {
        // 找出下面对应的nav实例
        function findTabNavVue(vueStance) {
          const childrens = vueStance.$children;
          const len = childrens.length;
          for (let i = 0; i < len; i++) {
            const child = childrens[i];
            if (child.scrollNext) return child;
          }
        }
        const navVue = findTabNavVue(this.$refs.tabs);
        if (navVue.$el.querySelector(".el-tabs__nav-prev")) {
          navVue.$el.querySelector(".el-tabs__nav-prev").style.visibility = "hidden";
        }
        if (navVue.scrollable) {
          let nextNode;
          let nextNode2;
          navVue.$watch("navOffset", function (currentOffset) {
            var navSize = this.$refs.nav["offsetWidth"];
            var containerSize = this.$refs.navScroll["offsetWidth"];
            const isRight = navSize - currentOffset <= containerSize;
            const isLeft = currentOffset == 0;
            nextNode = nextNode ? nextNode : navVue.$el.querySelector(".el-tabs__nav-next");
            nextNode.style.visibility = isRight ? "hidden" : "";

            nextNode2 = nextNode2 ? nextNode2 : navVue.$el.querySelector(".el-tabs__nav-prev");
            nextNode2.style.visibility = isLeft ? "hidden" : "";
          });
        }
      });
    },
    // 获取描述
    getDescription() {
      this.$http({
        url: "api/v1/concept/message?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.descLoading = false;
        this.conceptVal = res.data;
      });
    },
    handleClickTab(tab) {
      this.descLoading = true;
      this.editableTabsValue = this.conceptList[tab.index].name;
      this.conceptId = this.conceptList[tab.index].conceptId;
      setTimeout(() => {
        this.getDescription();
      }, 1200);
      this.$nextTick(() => {
        this.$refs.childRef.clearSearch();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  width: calc(100% - 32px);
  max-width: 1300px;
  min-width: 0;
  margin: 0 auto;
  .rotating-image {
    animation: rotate 1s linear infinite;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .page1 {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(39, 42, 46, 0.1);
    h3 {
      height: 62px;
      margin: -20px -20px 0;
      padding: 0 20px;
      color: #202224;
      font-size: 18px;
      line-height: 62px;
      background: url("../../assets/images/trend_h3.png") no-repeat 0;
      background-size: 240px 100%;
    }
    .page1-main {
      min-width: 0;
      min-height: 100px;
      .tabs-wrap {
        position: relative;
        display: flex;
        flex: auto;
        overflow: hidden;
        white-space: nowrap;
        transform: translate(0);
      }
    }
    ::v-deep .el-tabs__item {
      color: #636870;
      cursor: pointer;
      position: relative;
      font-size: 16px;
    }
    ::v-deep .is-active {
      color: #63ace5;
      font-size: 20px;
      font-weight: bold;
    }
    ::v-deep .el-tabs__item:hover {
      color: #63ace5;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #63ace5;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
    }
    ::v-deep .el-tabs__nav-wrap {
      padding: 0 25px;
      > span {
        font-size: 20px;
        line-height: 39px;
      }
    }
    ::v-deep .content {
      color: #636870;
      padding: 20px 0;
      font-size: 14px;
      line-height: 22px;
      overflow-wrap: anywhere;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    .page1-load {
      font-size: 14px;
      color: #636870;
      padding: 20px 0;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
      }
    }
    .tips {
      color: #969ca4;
      font-size: 12px;
      text-align: right;
      i {
        margin-right: 5px;
      }
    }
  }
  .wapper {
    min-width: 0;
    background: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    .tab-main {
      height: 62px;
      color: #202224;
      font-size: 18px;
      line-height: 62px;
      background: url("../../assets/images/trend_h3.png") no-repeat 0;
      background-size: 240px 100%;
      ::v-deep .el-tabs__active-bar {
        background-color: #63ace5;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      ::v-deep .el-tabs__nav-wrap {
        padding: 0 20px;
      }
      ::v-deep .el-tabs__item {
        font-size: 16px;
        color: #86909c;
      }
      ::v-deep .is-active {
        color: #202224;
        font-weight: bold;
      }
      ::v-deep .el-tabs {
        background: #fff;
      }
    }
    .tab-content {
      min-width: 0;
      padding: 20px;
    }
  }
}

@media (max-width: 768px) {
  .list-container {
    width: calc(100% - 24px);

    .page1 {
      margin-top: 12px;
      padding: 16px;

      h3 {
        height: 54px;
        margin: -16px -16px 0;
        padding: 0 16px;
        line-height: 54px;
      }

      ::v-deep .el-tabs__nav-wrap {
        padding: 0 20px;
      }

      ::v-deep .el-tabs__item {
        font-size: 14px;
      }

      ::v-deep .is-active {
        font-size: 17px;
      }

      .tips {
        line-height: 20px;
      }
    }

    .wapper {
      margin-top: 12px;

      .tab-main {
        height: 54px;
        line-height: 54px;

        ::v-deep .el-tabs__nav-wrap {
          padding: 0 12px;
        }

        ::v-deep .el-tabs__item {
          padding: 0 14px;
          font-size: 14px;
        }
      }

      .tab-content {
        padding: 16px;
      }
    }

    .tab-content {
      ::v-deep .filter-main {
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 10px 12px;

        .filter-item {
          flex: 1 1 240px;
          min-width: 0;

          label {
            flex: 0 0 auto;
          }

          .el-select,
          .el-input {
            width: 100%;
            min-width: 0;
            margin-right: 0;
          }
        }
      }

      ::v-deep .search_total {
        flex-wrap: wrap;
        gap: 10px;

        .search {
          width: 100%;
          margin-left: 0;
        }
      }

      ::v-deep .right-list li,
      ::v-deep .right-item li {
        min-width: 0;

        .right_index,
        .index {
          width: 36px;
          flex: 0 0 36px;
        }

        .right-content,
        .right-info {
          min-width: 0;
          overflow-wrap: anywhere;
        }

        .num {
          display: flex;
          flex-wrap: wrap;
          gap: 8px 14px;

          span {
            margin-right: 0;
          }
        }
      }

      ::v-deep .page4-main .right-item li {
        align-items: flex-start;

        .img {
          width: 112px;
          height: 112px;
          flex: 0 0 112px;
          margin-right: 14px;

          img {
            max-width: 110px;
            max-height: 110px;
          }
        }
      }

      ::v-deep .el-pagination {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px 0;
        white-space: normal;

        .el-pagination__sizes,
        .el-pagination__jump {
          margin-left: 0;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .list-container {
    .page1 {
      ::v-deep .el-tabs__nav-wrap {
        padding: 0 16px;
      }
    }

    .wapper .tab-content {
      padding: 12px;
    }

    .tab-content {
      ::v-deep .filter-main {
        flex-direction: column;

        .filter-item {
          width: 100%;
          flex-basis: auto;
        }
      }

      ::v-deep .right-list li,
      ::v-deep .right-item li {
        .right_index,
        .index {
          display: none;
        }
      }

      ::v-deep .page4-main .right-item li {
        .img {
          width: 88px;
          height: 88px;
          flex-basis: 88px;
          margin-right: 12px;

          img {
            max-width: 86px;
            max-height: 86px;
          }
        }
      }

      ::v-deep .el-pagination {
        .el-pagination__total,
        .el-pagination__sizes,
        .el-pagination__jump {
          display: none;
        }
      }
    }
  }
}
</style>
